import { render } from "./SnackbarNotify.vue?vue&type=template&id=3a16c809"
import script from "./SnackbarNotify.vue?vue&type=script&lang=js"
export * from "./SnackbarNotify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__